import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useState, useCallback, useMemo, useContext, useEffect } from "react";
import classnames from "classnames";
import styles from "@/styles/Notification.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotificationContext = /*#__PURE__*/createContext({
  showNotification: () => null,
  hideNotification: () => null
});
const initialValue = {
  message: null,
  props: {}
};
export function NotificationProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    0: notification,
    1: setNotification
  } = useState(initialValue);
  const showNotification = useCallback(function (message) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setNotification({
      message,
      props
    });
  }, []);
  const hideNotification = useCallback(function () {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setNotification(_objectSpread(_objectSpread({}, initialValue), {}, {
      props
    }));
  });
  const contextValue = useMemo(() => ({
    showNotification,
    hideNotification
  }), []);
  return /*#__PURE__*/_jsxs(NotificationContext.Provider, {
    value: contextValue,
    children: [children, /*#__PURE__*/_jsx(Notification, _objectSpread({
      message: notification.message
    }, notification.props))]
  });
}
export default function Notification(_ref2) {
  let {
    message,
    time = 5000,
    caution,
    fixed
  } = _ref2;
  const {
    hideNotification
  } = useContext(NotificationContext);
  const handleClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  useEffect(() => {
    let hideTimeoutId;
    if (message && !fixed) {
      hideTimeoutId = setTimeout(() => {
        hideNotification();
      }, time);
    }
    return () => {
      clearTimeout(hideTimeoutId);
    };
  }, [message]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.notification, {
      [styles.show]: !!message,
      [styles.caution]: caution
    }),
    children: message && /*#__PURE__*/_jsx("div", {
      className: styles.inner,
      onClick: handleClick,
      children: message
    })
  });
}